<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Importar unidades de negócio dos clientes
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info">
                                <i class="fas fa-info" aria-hidden="true"></i> Selecione um arquivo .csv para realizar a importação
                            </div>
                        </div>
                    </div>                      
                    <div class="row">
                        <div class="form-group col-12">
                            <span class="btn btn-light btn-file" [class.disabled]="uploader.isUploading">
                                Selecione o arquivo <input type="file" name="uploadfile" #inputFile accept="text/csv, .csv" ng2FileSelect [uploader]="uploader" [disabled]="uploader.isUploading"/>
                            </span>
                            {{fileName}}                                
                        </div>
                    </div>
                </form>
                <div class="alert alert-danger alert-error" role="alert" *ngIf="error">
                    <div id="messageError">
                        <p >{{error.message}}</p>
                        <p>Causa: {{error.cause}}</p>
                    </div>
                </div>                                
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="import()" id="btnImportClienteUnidadeNegocio" [disabled]="form.invalid || !fileName">
                    Importar
                </button>
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>